
const PROJECT_STATUS = {
    EMPTY: {value: 1, title: 'Prázdný projekt'},
    IMPORT_KU_DATA: {value: 2, title: 'Probíhá import katastrálních dat'},
    READY: {value: 3, title: 'Připraven'},
    IMPORT_KU_DATA_ERROR: {value: 4, title: 'Import katastrálních dat skončil chybou'},
    UPDATE_DATA_FROM_SOURCE: {value: 5, title: 'Probíhá aktualizace dat ze zdroje'}
};

function getTitle(value) {
    value = parseInt(value);
    let title = '';
    for (let statusName in PROJECT_STATUS) {
        let status = PROJECT_STATUS[statusName];
        if (status.value === value) {
            title = status.title;
        }
    }
    return title;
}

module.exports = {
    PROJECT_STATUS,
    getTitle: getTitle
};
